// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:37:28

export default {
  "id": "team-loyalty",
  "slug": "team-loyalty",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/0bd16f237d264c17b93906dcf0e295ae-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/0bd16f237d264c17b93906dcf0e295ae/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Team Loyalty",
      "description": "Build your crowd and claim victory! In this addictive game, you begin with a single character, but things quickly escalate as you pass through numbered gates and grow your crowd. Dodge obstacles, expand your group, and outnumber your enemies to win. The largest and strongest crowd prevails — can you assemble the biggest one and emerge victorious?",
      "instructions": "Control the characters by swiping left and right with your mouse on Desktop. For mobile control, you can move the characters by swiping right and left with your finger.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "collect",
        "combat",
        "runner"
      ]
    },
    "zh-CN": {
      "title": "队伍忠诚度",
      "description": "建造你的队伍，夺取胜利！在这款令人上瘾的游戏中，你从单个角色开始，但随着你通过编号的大门并壮大你的队伍，局势迅速升级。躲避障碍，扩展你的团队，以数量优势击败敌人以获胜。最大最强大的队伍将获胜——你能组建最大的队伍并最终胜出吗？",
      "instructions": "在桌面端通过鼠标左右滑动来控制角色。在移动端，你可以通过手指左右滑动来移动角色。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "收集",
        "战斗",
        "跑酷"
      ]
    },
    "zh-TW": {
      "title": "隊伍忠誠度",
      "description": "建造你的群眾，宣告勝利！在這款令人上癮的遊戲中，你從單一角色開始，但隨著你通過編號的閘門並擴大你的群眾，事情迅速升級。躲避障礙，擴展你的團隊，並以人數超越敵人來獲勝。最大最強的群眾將獲勝——你能組建最龐大的群眾並最終獲勝嗎？",
      "instructions": "在電腦上通過滑鼠左右滑動來控制角色。在手機上，你可以通過手指左右滑動來移動角色。",
      "genres": [
        "休閒"
      ],
      "tags": [
        "收集",
        "戰鬥",
        "跑酷遊戲"
      ]
    },
    "zh-HK": {
      "title": "隊伍忠誠度",
      "description": "建立你的群衆，奪取勝利！在這款令人上癮的遊戲中，你從單一角色開始，但隨著你通過編號的閘門，你的群衆將迅速擴大。躲避障礙，擴展你的團隊，以數量優勢擊敗敵人來獲勝。最大最強的群衆將獲勝——你能組織起最龐大的群衆並最終勝出嗎？",
      "instructions": "在桌面版上，通過鼠標左右滑動來控制角色。在手機操控方面，你可以通過手指左右滑動來移動角色。",
      "genres": [
        "休閒"
      ],
      "tags": [
        "收集",
        "戰鬥",
        "跑酷遊戲"
      ]
    },
    "ja": {
      "title": "チームロイヤルティ",
      "description": "群衆を築き、勝利を手に入れろ！この中毒性のあるゲームでは、最初は1人のキャラクターから始めるが、番号付きのゲートを通過するたびに群衆は急速に増えていく。障害物を避け、グループを拡大し、敵を数で圧倒して勝利を目指せ。最も大きく強い群衆が勝利を収める—最大の群衆を編成し、勝利を収めることができるか？",
      "instructions": "デスクトップではマウスで左右にスワイプしてキャラクターを操作します。モバイルコントロールでは、指で右左にスワイプしてキャラクターを移動できます。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "収集",
        "戦闘",
        "ランナー"
      ]
    },
    "ko": {
      "title": "팀 충성도",
      "description": "군중을 키우고 승리를 주장하세요! 이 중독성 있는 게임에서는 한 명의 캐릭터로 시작하지만, 번호가 매겨진 게이트를 통과하면서 군중이 빠르게 커집니다. 장애물을 피하고, 그룹을 확장하며, 적보다 많은 수로 승리하세요. 가장 크고 강한 군중이 승리합니다 — 가장 큰 군중을 조직하고 승리할 수 있을까요?",
      "instructions": "데스크탑에서는 마우스를 좌우로 슬라이드하여 캐릭터를 조작합니다. 모바일 조작 시, 손가락으로 오른쪽과 왼쪽으로 슬라이드하여 캐릭터를 이동할 수 있습니다.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "수집",
        "전투",
        "러너"
      ]
    },
    "fr": {
      "title": "Loyauté d'Équipe",
      "description": "Construisez votre foule et revendiquez la victoire ! Dans ce jeu addictif, vous commencez avec un seul personnage, mais les choses s'intensifient rapidement à mesure que vous passez par des portes numérotées et agrandissez votre foule. Esquivez les obstacles, étendez votre groupe et surpassiez vos ennemis en nombre pour gagner. La foule la plus grande et la plus forte l'emporte — pouvez-vous assembler la plus grande et émerger victorieux ?",
      "instructions": "Contrôlez les personnages en glissant votre souris vers la gauche et la droite sur ordinateur. Pour les commandes sur mobile, vous pouvez déplacer les personnages en glissant votre doigt vers la droite et la gauche.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "collecte",
        "combat",
        "coureur"
      ]
    }
  }
};
